// src/modules/app-views/_apps/appsindico/parkingSpots/pages/Document/tabs/RecordTab.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Row, Col } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import SimpleNumber from 'components/SimpleComponents/SimpleNumber';
import SimpleTextArea from 'components/SimpleComponents/SimpleTextArea';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const RecordTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <>
      <Row gutter={ROW_GUTTER}>
        <Col xs={24} sm={8}>
          <SimpleInput name="number" label="spot_number" required />
        </Col>
        <Col xs={24} sm={8}>
          <SimpleInput name="floor" label="floor" />
        </Col>
        <Col xs={24} sm={8}>
          <SimpleSelect
            name="type"
            label="type"
            options={[
              { value: 'covered', label: translateX('covered') },
              { value: 'uncovered', label: translateX('uncovered') },
              { value: 'garage_box', label: translateX('garage_box') },
            ]}
          />
        </Col>
      </Row>

      <Row gutter={ROW_GUTTER}>
        <Col xs={24} sm={8}>
          <SimpleSelect
            name="status"
            label="status"
            options={[
              { value: 'available', label: translateX('available') },
              { value: 'occupied', label: translateX('occupied') },
              { value: 'rented', label: translateX('rented') },
              { value: 'sold', label: translateX('sold') },
            ]}
          />
        </Col>
        <Col xs={24} sm={8}>
          <SimpleNumber name="rentalValue" label="rental_value" />
        </Col>
      </Row>

      <Row gutter={ROW_GUTTER}>
        <Col xs={24}>
          <SimpleTextArea name="observation" label="observation" rows={3} />
        </Col>
      </Row>
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default RecordTab;
